const removeUndefinedProperties = <T extends Object> (obj: T): T => {
    return Object.fromEntries(Object.entries(obj).filter(entry => entry [1] !== undefined)) as T;
}

export default removeUndefinedProperties;
